import FrontElement from 'components/FrontElement'
import data_51 from 'Assets/data_51.json'
import data_50 from 'Assets/data_50.json'
import styled from 'styled-components'
import { SwissParties } from './SwissParties'

// Lieber Sven Ich hoffe du findest dich in meinem Spaghetticode 🍝 zu recht.
// LG Dariush bin wahrscheinlich jetzt schon in Sardinien am strand hehe 🌊

const PartyLabel = styled.b`
  padding: 1px 4px;
  color: white;
  content: 'SP';
`

export const scenes: Scene[] = [
  {
    frontElement: (
      <FrontElement>
        <p>
          Hier die Linken, da die Bürgerlichen: Diese beiden Lager prägen nach
          landläufiger Meinung die Schweizer Politik. Die Studie von Leemann und
          Bindung zeigt nun aber, dass man eigentlich von drei statt zwei Lagern
          sprechen muss.
        </p>
        <p>
          Die{' '}
          <PartyLabel style={{ background: SwissParties['SVP'].color }}>
            SVP
          </PartyLabel>{' '}
          steht so viel weiter rechts als alle anderen Fraktionen, dass sie
          gewissermassen einen Block für sich alleine bildet. Die{' '}
          <PartyLabel style={{ background: SwissParties['FDP'].color }}>
            FDP
          </PartyLabel>
          , die{' '}
          <PartyLabel style={{ background: SwissParties['Mitte'].color }}>
            Mitte-Partei
          </PartyLabel>{' '}
          und die{' '}
          <PartyLabel style={{ background: SwissParties['GLP'].color }}>
            GLP
          </PartyLabel>{' '}
          bilden gemeinsam einen Block im politischen Zentrum. Die{' '}
          <PartyLabel style={{ background: SwissParties['SP'].color }}>
            SP
          </PartyLabel>{' '}
          und die{' '}
          <PartyLabel style={{ background: SwissParties['GPS'].color }}>
            Grünen
          </PartyLabel>{' '}
          setzen sich deutlich nach links ab. Bei gewissen Themen ist die
          Dreiteiligkeit besonders ausgeprägt, am stärksten bei der Migration.
          Bei anderen Themen, vor allem bei den sozialpolitischen, sind die
          Übergänge fliessender.
        </p>
      </FrontElement>
    ),
    legislature: data_51,
    category: 'all',
    title: 'Dreigeteiltes Parlament',
    partyFilter: ['FDP', 'GLP', 'SVP', 'SP', 'Mitte', 'GPS'],
    // highlightMembers: ['Erich Hess'],
  },
  {
    frontElement: (
      <FrontElement>
        <p>
          Bei gewissen Themen ist die Dreiteiligkeit besonders ausgeprägt, am
          stärksten bei der Migration. Bei anderen Themen, vor allem bei den
          sozialpolitischen, sind die Übergänge fliessender.
        </p>
      </FrontElement>
    ),
    legislature: data_51,
    category: 'migration',
    title: 'Dreigeteiltes Parlament',
    partyFilter: ['FDP', 'GLP', 'SVP', 'SP', 'Mitte', 'GPS'],
    // highlightMembers: ['Erich Hess'],
  },
  {
    frontElement: (
      <FrontElement>
        Insgesamt stehen die{' '}
        <PartyLabel style={{ background: SwissParties['GPS'].color }}>
          Grünen
        </PartyLabel>{' '}
        als Fraktion am weitesten links. Das gilt aber nicht für jeden
        Themenbereich. Bei sozialen Themen sind die{' '}
        <PartyLabel style={{ background: SwissParties['SP'].color }}>
          Sozialdemokraten
        </PartyLabel>{' '}
        am linken Rand.
      </FrontElement>
    ),
    legislature: data_51,
    category: 'social',
    title: 'Unklare Fronten links',
    partyFilter: ['GPS', 'GLP', 'SVP', 'SP', 'SVP'],
  },
  {
    frontElement: (
      <FrontElement>
        Und bei Umwelt und Energie bilden{' '}
        <PartyLabel style={{ background: SwissParties['SP'].color }}>
          SP
        </PartyLabel>
        ,{' '}
        <PartyLabel style={{ background: SwissParties['GPS'].color }}>
          Grüne
        </PartyLabel>{' '}
        und{' '}
        <PartyLabel style={{ background: SwissParties['GLP'].color }}>
          GLP
        </PartyLabel>{' '}
        eine Art Cluster - mit den Grünliberalen als tendenziell progressivste
        Fraktion. Klare Verhältnisse herrschen dagegen rechts. Niemand reicht
        hier auch nur ansatzweise an die{' '}
        <PartyLabel style={{ background: SwissParties['SVP'].color }}>
          SVP
        </PartyLabel>{' '}
        heran, sowohl in der Gesamtauswertung als auch in den einzelnen
        Themenbereichen.
      </FrontElement>
    ),
    legislature: data_51,
    category: 'environment',
    title: 'Unklare Fronten links',
    partyFilter: ['GPS', 'GLP', 'SVP', 'SP', 'SVP'],
  },
  {
    frontElement: (
      <FrontElement>
        Erich Hess,{' '}
        <PartyLabel style={{ background: SwissParties['SVP'].color }}>
          SVP
        </PartyLabel>
        -Nationalrat aus dem Kanton Bern, steht gleich in vier der fünf
        ausgewerteten Themenbereichen (Soziale Themen, Wirtschaft, Finanzen und
        Steuern, Umwelt und Energie) am weitesten rechts.
      </FrontElement>
    ),
    legislature: data_51,
    category: 'all',
    title: 'Rechter Rekordhalter',
    partyFilter: ['SVP'],
    highlightMembers: ['Erich Hess'],
  },
  {
    frontElement: (
      <FrontElement>
        Einzig im{' '}
        <PartyLabel style={{ background: SwissParties['SVP'].color }}>
          SVP
        </PartyLabel>
        -Kernthema Migration wird Hess noch von fünf Hardlinern aus seiner
        Fraktion übertroffen, am deutlichsten von Benjamin Fischer aus Zürich.
        In der Gesamtauswertung macht dies Hess zum Rechtesten unter den
        Rechten: Er erreicht einen Wert von 16,7 auf der Links-Rechts-Skala (je
        höher der Wert, desto rechter). Zum Vergleich: Der Zweitplatzierte
        Pirmin Schwander kommt auf 13,3, das Gros der SVP-Fraktion auf Werte
        zwischen 9 und 11. Magdalena Martullo-Blocher zum Beispiel liegt bei
        10,7 und Albert Rösti bei 9,9.
      </FrontElement>
    ),
    legislature: data_51,
    category: 'migration',
    title: 'Rechter Rekordhalter',
    partyFilter: ['SVP'],
    highlightMembers: ['Erich Hess'],
  },
  {
    frontElement: (
      <FrontElement>
        Auf der Schweizer Landkarte liegt Genf ganz links - und tatsächlich
        stellt der Kanton auch die beiden linksten Mitglieder des Nationalrats:
        die{' '}
        <PartyLabel style={{ background: SwissParties['GPS'].color }}>
          Grünen
        </PartyLabel>{' '}
        Nicolas Walder und Delphine Klopfenstein Broggini. Ihre Werte betragen
        -10.82 (Walder) beziehungsweise -10.81 (je tiefer im Minus, desto
        linker). Die Romandie ist auf der linken Seite generell stark vertreten:
        Zu den “Top ten” gehören auch die Grünen Valentine Python und Léonore
        Porchet aus Waadt sowie Fabien Fivaz aus Neuenburg. Für Neuenburg
        politisiert ferner der PdA-Nationalrat Denis de la Reussille, der letzte
        Kommunist im Parlament. Mit einem Wert von -10.41 liegt er ebenfalls
        nahe am Spitzengrüppchen. Bemerkenswert ist dagegen die Position von
        Stéfanie Prezioso Batou, der einzigen Nationalrätin des Genfer Ensemble
        à Gauche: Das Bündnis gilt gemeinhin als linksradikal, doch mit einem
        Wert von bloss -8.67 ist Prezioso eher den zentristischen Linken
        zuzurechnen.
      </FrontElement>
    ),
    legislature: data_51,
    category: 'all',
    title: 'Linkster Kanton',
    partyFilter: ['SP', 'GPS', 'GLP'],
    highlightMembers: [
      'Nicolas Walder',
      'Delphine Klopfenstein Broggini',
      'Stéfanie Prezioso Batou',
    ],
  },
  {
    frontElement: (
      <FrontElement>
        Manche Fraktionsmitglieder fallen durch ihre Positionierung aus dem
        Rahmen. Der Innerrhoder{' '}
        <PartyLabel style={{ background: SwissParties['Mitte'].color }}>
          Mitte
        </PartyLabel>
        -Nationalrat Thomas Rechsteiner ist ein einsamer Rechtsabbieger in
        seiner Fraktion: Aufgrund seiner Positionen wäre er dem rechten{' '}
        <PartyLabel style={{ background: SwissParties['FDP'].color }}>
          FDP
        </PartyLabel>
        -Flügel zuzuordnen.
      </FrontElement>
    ),
    legislature: data_51,
    category: 'all',
    title: 'Prominente Abweichler',
    partyFilter: ['FDP', 'Mitte'],
    highlightMembers: ['Thomas Rechsteiner'],
  },
  {
    frontElement: (
      <FrontElement>
        Die{' '}
        <PartyLabel style={{ background: SwissParties['FDP'].color }}>
          FDP
        </PartyLabel>{' '}
        wiederum hat dafür einen prominenten Linksabweichler. Am weitesten links
        steht ausgerechnet Damien Cottier, der Fraktionschef. Er würde sich mit
        seinen Ansichten wohl auch in der
        <PartyLabel style={{ background: SwissParties['Mitte'].color }}>
          Mitte
        </PartyLabel>{' '}
        gut aufgehoben fühlen.
      </FrontElement>
    ),
    legislature: data_51,
    category: 'all',
    title: 'Prominente Abweichler',
    partyFilter: ['FDP', 'Mitte'],
    highlightMembers: ['Damien Cottier'],
  },
  {
    frontElement: (
      <FrontElement>
        Die bürgerlichen Fraktionen könnten darüber hinaus Gefallen am{' '}
        <PartyLabel style={{ background: SwissParties['SP'].color }}>
          SP
        </PartyLabel>
        -Bundesratskandidaten Beat Jans finden. Laut dem Rating ist er der
        rechteste Sozialdemokrat. Allerdings ist die Auswertung der laufenden
        Legislatur für Jans nur bedingt aussagekräftig, da er aufgrund seiner
        Wahl in die Basler Regierung schon Ende 2020 aus dem Nationalrat
        zurücktrat. In früheren Legislaturen votierte Jans teils deutlich
        linker. Die rechtesten Linken überhaupt sind interessanterweise zwei{' '}
        <PartyLabel style={{ background: SwissParties['GPS'].color }}>
          Grünen
        </PartyLabel>
        , Natalie Imboden (Bern) und Raphaël Mahaim (Waadt). Sie lassen die
        gesamte SP -Fraktion links neben sich liegen und könnten auch bei den
        Grünliberalen sein.
      </FrontElement>
    ),
    legislature: data_51,
    category: 'all',
    title: 'Prominente Abweichler',
    partyFilter: ['GLP', 'GPS', 'SP'],
    highlightMembers: ['Beat Jans'],
  },
  {
    frontElement: (
      <FrontElement>
        Die rechtesten Linken überhaupt sind interessanterweise zwei{' '}
        <PartyLabel style={{ background: SwissParties['GPS'].color }}>
          Grünen
        </PartyLabel>
        , Natalie Imboden (Bern) und Raphaël Mahaim (Waadt). Sie lassen die
        gesamte{' '}
        <PartyLabel style={{ background: SwissParties['SP'].color }}>
          SP
        </PartyLabel>
        -Fraktion links neben sich liegen und könnten auch bei den{' '}
        <PartyLabel style={{ background: SwissParties['GLP'].color }}>
          Grünliberalen
        </PartyLabel>
        sein.
      </FrontElement>
    ),
    legislature: data_51,
    category: 'all',
    title: 'Prominente Abweichler',
    partyFilter: ['GLP', 'GPS', 'SP'],
    highlightMembers: ['Natalie Imboden', 'Raphaël Mahaim'],
  },
  {
    frontElement: (
      <FrontElement>
        Vergleicht man das Gesamtbild mit demjenigen der vergangenen drei
        Legislaturen, fällt vor allem ein Unterschied auf: Die{' '}
        <PartyLabel style={{ background: SwissParties['GPS'].color }}>
          Grünen
        </PartyLabel>{' '}
        haben die{' '}
        <PartyLabel style={{ background: SwissParties['SP'].color }}>
          SP
        </PartyLabel>{' '}
        vom linken Rand verdrängt. Zwar haben sich die beiden Fraktionen nie
        stark unterschieden mit ihren Positionen. Doch insgesamt war die SP
        etwas progressiver unterwegs. In der laufenden Legislatur ist das nun
        anders. Deutlich zeigt sich das etwa bei der Migration, wo die Grünen
        zuletzt viel linker stimmten als die SP . Vor den Wahlen 2019 war es
        umgekehrt.
      </FrontElement>
    ),
    legislature: data_50,
    category: 'all',
    title: 'Getauschte Plätze',
    partyFilter: ['SP', 'GPS'],
  },
  {
    frontElement: (
      <FrontElement>
        Vergleicht man das Gesamtbild mit demjenigen der vergangenen drei
        Legislaturen, fällt vor allem ein Unterschied auf: Die{' '}
        <PartyLabel style={{ background: SwissParties['GPS'].color }}>
          Grünen
        </PartyLabel>{' '}
        haben die{' '}
        <PartyLabel style={{ background: SwissParties['SP'].color }}>
          SP
        </PartyLabel>{' '}
        vom linken Rand verdrängt. Zwar haben sich die beiden Fraktionen nie
        stark unterschieden mit ihren Positionen. Doch insgesamt war die SP
        etwas progressiver unterwegs. In der laufenden Legislatur ist das nun
        anders. Deutlich zeigt sich das etwa bei der Migration, wo die Grünen
        zuletzt viel linker stimmten als die SP . Vor den Wahlen 2019 war es
        umgekehrt.
      </FrontElement>
    ),
    legislature: data_51,
    category: 'all',
    title: 'Getauschte Plätze',
    partyFilter: ['SP', 'GPS'],
  },
]

/* <b style=" padding:1px 4px"> */
